document.addEventListener('DOMContentLoaded', () => {
    const vacationModal =  document.querySelector('#vacation');
    if (vacationModal) {
        vacationModal.showModal();
        const closeBtn = vacationModal.querySelector('.close-modal');
        closeBtn.addEventListener('click', (e) => {
            e.target.parentElement.close();
        })
        vacationModal.addEventListener("click", (event) => {
            const rect = vacationModal.getBoundingClientRect();
            const isInDialog =
            event.clientX >= rect.left &&
            event.clientX <= rect.right &&
            event.clientY >= rect.top &&
            event.clientY <= rect.bottom;

            if (!isInDialog) {
                vacationModal.close();
            }
        });
        const pauseNoticeBtn = document.querySelector('.pause-notice');
        if (pauseNoticeBtn) {
            pauseNoticeBtn.addEventListener('click', () => {
                vacationModal.showModal();
            })
        }
    }
})